module.exports = __webpack_public_path__ + "static/USLPA_Team_Reps_2021-31e256eb0ec5a6c8cf288da060e5725b.pdf";